import { defineSlotRecipe } from "@pandacss/dev";
import { tabsAnatomy } from "@ark-ui/react";

export const aromaTabs = defineSlotRecipe({
  className: "aroma-tabs",
  jsx: ["Tabs"],
  slots: tabsAnatomy.keys(),
  base: {
    list: {
      display: "flex",
      height: "2xl",
      borderBottom: "{borderWidths.m} solid",
      borderColor: "border.neutral.subtle",
      marginBottom: "margin.4",
    },
    trigger: {
      position: "relative",
      height: "2xl",
      gap: "gap.2",
      py: "padding.1,5",
      px: "padding.4",
      borderBottom: "{borderWidths.m} solid",
      borderColor: "border.neutral.subtle",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "content.neutral.base.subtlest",
      textStyle: "title.s",
      textWrap: "nowrap",
      textAlign: "center",
      zIndex: "1",
      _selected: {
        borderBottom: "{borderWidths.l} solid",
        color: "content.brand.bold",
        borderColor: "border.brand",
        cursor: "default",
        pb: "padding.1",
        _before: {
          background: "background.brand.subtle",
          bottom: "padding.1",
        },
        _hover: {
          _before: {
            background: "background.brand.subtle",
          },
        },
      },
      _hover: {
        _before: {
          backgroundColor: "background.neutral.base.subtlest-hover",
        },
      },
      _before: {
        content: "''",
        borderRadius: "m",
        top: "padding.1,5",
        left: "padding.2",
        right: "padding.2",
        bottom: "padding.1,5",
        position: "absolute",
        zIndex: "-1",
        transition: "background-color 0.3s ease-in-out",
      },
    },
  },
  variants: {
    align: {
      left: {
        list: {
          justifyContent: "start",
        },
      },
      center: {
        list: {
          justifyContent: "space-between",
        },
        trigger: {
          display: "flex",
          width: "100%",
        },
      },
    },
  },
  defaultVariants: {
    align: "left",
  },
});
